import { render } from "./film.vue?vue&type=template&id=ba900b2e&scoped=true"
import script from "./film.vue?vue&type=script&lang=js"
export * from "./film.vue?vue&type=script&lang=js"

import "./film.vue?vue&type=style&index=0&id=ba900b2e&scoped=true&lang=css"

import exportComponent from "/root/workspace/cinema-admin_TXA8/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba900b2e"]])

export default __exports__